'use client';

import { Children, cloneElement } from 'react';

import { useProvider } from './Provider';

import type { FC, ReactElement } from 'react';

export interface ConsumerProps {
  children: ReactElement;
}

/**
 * Consumes the Context from a Provider and passes the data down as props <br>
 * Children can receive the data over the "data" prop
 */
export const Consumer: FC<ConsumerProps> = ({ children, ...props }) => {
  const data = useProvider();

  return (
    <>
      {Children.map( children, (child, index) =>
        cloneElement( child, {
          key: index,
          data,
          ...props,
        } ) )}
    </>
  );
};
